import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPinCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPinCircle"><Path d="M12 12.2473V17.25M13.9443 7.55533C15.0186 8.62963 15.0186 10.3714 13.9443 11.4447C12.8701 12.5179 11.1284 12.519 10.0553 11.4447C8.9821 10.3704 8.98105 8.62858 10.0553 7.55533C11.1295 6.48208 12.8701 6.48103 13.9443 7.55533ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPinCircle;
